import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import CircularProgress from '@material-ui/core/CircularProgress';
import { Typography } from '@material-ui/core';

const useStyles = makeStyles(theme => ({
  progress: {
    margin: theme.spacing(2),
    position: 'absolute',
    left:'50%',
    top: '50%',
    marginTop:'1%',
    transform:'translate(-50%,-50%)'
  },
  title: {
    margin: theme.spacing(2),
    position: 'absolute',
    left:'50%',
    top: '47%',
 
    transform:'translate(-50%,-50%)'
  },
  overlay: {
    backgroundColor: 'rgba(255,255,255,0.5)',
    width: '100%',
    height: '100%',
    position: 'fixed',
    zIndex: '9999',
    top: '0',
    bottom: '0',
    left: '0',
    right: '0'
  }
}));

function GlobalLoader(props) {
  const classes = useStyles();
  const [progress, setProgress] = React.useState(0);

  React.useEffect(() => {
    function tick() {
      // reset when reaching 100%
      setProgress(oldProgress => (oldProgress >= 100 ? 0 : oldProgress + 1));
    }

    const timer = setInterval(tick, 20);
    return () => {
      clearInterval(timer);
    };
  }, []);

  return (
    <div className={classes.overlay}>
      <div className={classes.title}>  <Typography variant="h5" component="h4">{props.title?props.title:""}</Typography></div>
    
      <CircularProgress
        className={classes.progress}
        variant="determinate"
        value={progress}
        color="secondary"
      />
    </div>
  );
}

export default GlobalLoader;